import React from 'react';
import SwiperCore, { Autoplay } from 'swiper';
import 'swiper/components/effect-coverflow/effect-coverflow.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import { ReactComponent as CameraPermission } from '../../assets/icons/camera_permission.svg';
import { ReactComponent as CameraPermission2 } from '../../assets/icons/camera_permission_2.svg';
import { ReactComponent as CameraPermission3 } from '../../assets/icons/camera_permission_3.svg';
import { ReactComponent as CameraPermission4 } from '../../assets/icons/camera_permission_4.svg';
import './Hints.sass';

SwiperCore.use([Autoplay]);

const Hints = () => {
	return (
		<div className="hints">
			<Swiper
				effect="coverflow"
				loop
				slidesPerView={1}
				autoplay={{
					delay: 3000,
					disableOnInteraction: false,
				}}
				allowTouchMove={false}>
				<SwiperSlide>
					<CameraPermission className="hint" />
				</SwiperSlide>
				<SwiperSlide>
					<CameraPermission4 className="hint" />
				</SwiperSlide>
				<SwiperSlide>
					<CameraPermission2 className="hint" />
				</SwiperSlide>
				<SwiperSlide>
					<CameraPermission3 className="hint" />
				</SwiperSlide>
			</Swiper>
		</div>
	);
};

export default Hints;
